import { CircularProgress as MuiCircularProgress } from '@mui/material';

import './Spinner.scss';

const Spinner = ({ size, className = '' }: { size?: number | string; className?: string }) => {
    return <MuiCircularProgress className={`loading-spinner ${className}`} size={size} />;
};

export default Spinner;
